import { useEffect, useState } from "react";
import { countExtentFromWKTFeatures } from "../../../widgets/map/mapFeatures/helpers";
import { getAllObjectsLayer, getWKTFeatureVectorLayer } from "../../../widgets/map/mapFeatures/layers";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import SmallLoader from "../../../widgets/loaders/SmallLoader";
import { fetchObjectGeometry } from "../../../api/mapApi";

type ObjectCardMapProps = {
    urlType: string
    objectTypeName: string
    objectId: string
    mapEventHandlers?: any
    mapInfoWidgetIsShown?: boolean
    onMapReady?: (map: any) => void
    onGeometryLoaded?: (geometry: any, extent: any) => void
    onLoadingChange?: (isLoading: boolean) => void
    onError?: (isError: boolean) => void
}

export default function ObjectCardMap({ urlType, objectTypeName, objectId, mapEventHandlers, mapInfoWidgetIsShown = false, onMapReady, onGeometryLoaded, onLoadingChange, onError }: ObjectCardMapProps) {
    const [additionalLayers, setAdditionalLayers] = useState<any[]>([])
    const [permanentLayers] = useState<any[]>([getAllObjectsLayer()])
    const [fitExtent, setFitExtent] = useState<any>()
    const [fitExtentPadding, setFitExtentPadding] = useState<any>([])
    const [isFetching, setIsFetching] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)

    useEffect(() => {
        let isMounted = true
        const controller = new AbortController()
        const load = async () => {
            setIsFetching(true)
            setIsError(false)
            onLoadingChange?.(true)
            try {
                let { data: objectWKTGeometry, isError, isSuccess } = await fetchObjectGeometry(urlType, objectTypeName, objectId, { signal: controller.signal })
                if (!isMounted) return
                setIsError(!!isError)
                onError?.(!!isError)
                setIsFetching(false)
                onLoadingChange?.(false)
                if (isSuccess && objectWKTGeometry) {
                    const layer = getWKTFeatureVectorLayer(objectWKTGeometry)
                    setAdditionalLayers([layer])
                    const extent = countExtentFromWKTFeatures(objectWKTGeometry)
                    setFitExtent(extent)
                    setFitExtentPadding([50, 50, 50, 50])
                    onGeometryLoaded?.(objectWKTGeometry, extent)
                }
            } catch (error: any) {
                if (!isMounted) return
                // отмена запроса (AbortController) — не ошибка
                if (error?.name === 'AbortError') return
                setIsError(true)
                onError?.(true)
                setIsFetching(false)
                onLoadingChange?.(false)
            }
        }
        load()
        return () => { isMounted = false; controller.abort() }
    }, [urlType, objectTypeName, objectId])

    if (isFetching) {
        return (
            <div className="map-widget-table-object-info loader">
                <SmallLoader />
            </div>
        )
    }
    if (isError) return null

    return (
        <div className="map-widget-table-object-info">
            <MapWidget
                mapStateReturnFunc={onMapReady}
                additionalLayers={additionalLayers}
                permanentLayers={permanentLayers}
                propsFitExtent={fitExtent}
                propsFitExtentPadding={fitExtentPadding}
                mapEventHandlers={mapEventHandlers}
                mapInfoWidgetIsShown={mapInfoWidgetIsShown}
                mapType="card"
            />
        </div>
    )
}


